import template from './move-offer-card.html';
import './move-offer-card.global.css';

export const MoveOfferCardComponent = {
  template,
  bindings: {
    offer: '<',
  },
};
